import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getPlanes = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/planes?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getPlanesActivos = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/planes/activos?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const getPlanesActivosOnBoard = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/planes/activos/onboard?empresa=67fb199c799c1b69ec40fa38`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getPlanesMarcados = async () => {
  // Simulación de API, puedes cambiar a un fetch real
  return [1, 3]; // IDs de los planes seleccionados
};

  export const crearPlan = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/planes', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updatePlan = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/planes/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deletePlan = (Id) => Axios.delete(`/planes/${Id}`);
